import React, { useState, useEffect, createContext, useContext } from 'react';

const SongDataContext = createContext();
const SongDataUpdateContext = createContext();


export function SongDataProvider({ children, initialData }) {
  const [songData, setSongData] = useState(initialData);

  // Provide an update function that external scripts can call
  const updateSongData = (newData) => {
    setSongData(newData);
    //console.log("NEW:\n" + JSON.stringify(newData, null, 4));
  };

  return (
    <SongDataContext.Provider value={songData}>
      <SongDataUpdateContext.Provider value={updateSongData}>
        {children}
      </SongDataUpdateContext.Provider>
    </SongDataContext.Provider>
  );
}

export function useSongData() {
  return useContext(SongDataContext);
}

export function useUpdateSongData() {
  return useContext(SongDataUpdateContext);
}


function Tag({ tag, name, onDelete, onAdd, songId, selected }) {
  let [status, setStatus] = useState(0);

  if (onAdd) {
    return (
      <div
        onClick={() => { onAdd(tag); setStatus(1); }}
        className="tag-box" style={{
          fontSize: "2.2em",
          backgroundColor: (status == 1 || selected) ? "cornflowerblue" : "lightgrey", borderRadius: 5, borderWidth: 3, borderColor: "grey", margin: "40", padding: "40" }} >
        <span>{name}</span>
        <button className="tag-add" onClick={() => {
          //onAdd(tag); setStatus(1); 
        }}>+</button>
      </div>
    );
  }
  else
    return (
      <div
        onClick={() => { onDelete(tag); setStatus(-1) }}
        className="tag-box" style={{
          fontSize: "2.2em",
          backgroundColor: (status == -1) ? "red" : "lightgreen", borderRadius: 5, borderWidth: 3, borderColor: "grey", margin: "40", padding: "40" }} >
        <span>{name}</span>
        <button className="tag-delete" style={{}} onClick={() => {
          //onDelete(tag); setStatus(-1)
        }}>×</button>
      </div>
    );
}

function TagAdder({ category, onAdd, songId, options }) {
  const [newTag, setNewTag] = React.useState('');
  let [addableTags, setAddableTags] = useState({});
  let [addedTags, setAddedTags] = useState({});

  if (options == undefined) {
    options = {};
  }

  const handleAdd = () => {
    if (newTag.trim()) {
      //onAdd(newTag.trim());
      //setNewTag('');
      getAddableTags();
    }
  };

  const getAddableTags = () => {
    //console.log("GETTING ADDABLE TAGS");
    //console.log("OPTIONS:" + Object.keys(options).length);
    let addableTags0 = {};
    for (let tag in options) {
      let tagName = options[tag];
      if (tagName.indexOf(",") != -1)
        tagName = tagName.split(",")[0];
      tagName = tagName.toLowerCase().trim();
      if (newTag != "" && newTag.length > 1 && !(tag in addedTags) && (tagName.includes(newTag.toLowerCase()))) {
        addableTags0[tag] = options[tag];
      }
    }

    setAddableTags(addableTags0);
  }

  const addTag = (tag) => {
    //onAdd(tag);
    let addedTags0 = addedTags;
    addedTags0[tag] = options[tag];
    setAddedTags(addedTags0);

    let addableTags0 = {}; // addableTags;
    //delete addableTags0[tag];
    setAddableTags(addableTags0);

    setNewTag('');
  }

  return (
    <div className="tag-adder" >
      <input
        type="text"
        style={{ width: "93%" }}
        value={newTag}
        onChange={(e) => setNewTag(e.target.value)}
        placeholder={`Add a tag to ${category}`}
      />
      <button className='btn' style={{ width: "100%" }} onClick={handleAdd} > Search </button>

      <div>
        <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

          {Object.entries(addedTags).map(([tag, name]) => (
            <div style={{ padding: "20px" }}>
              <Tag
                key={tag + songId}
                type="a"
                selected={true}
                tag={tag}
                name={name}
                onAdd={() => { addTag(tag); onAdd(tag) }}
              />
            </div>
          ))}
        </div>
        <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

          {Object.entries(addableTags).map(([tag, name]) => (
            <div style={{ padding: "20px" }}>
              <Tag
                key={tag + songId}
                type="a"
                tag={tag}
                name={name}
                onAdd={() => { addTag(tag); onAdd(tag) }}
              />
            </div>
          ))}
        </div>


      </div>


    </div>
  );
}

function TagCategory({ category, tags, names, onAddTag, onDeleteTag, options, songId }) {


  let error = false;
  try {
    if (tags == undefined || tags == [] || tags.length == 0) {
      error = true;
    }
    tags.map((tag) => { });
  }
  catch (e) {
    error = true;
  }
  if (options == undefined) {
    options = {};
  }

  //console.log("TAG CATEGORY:"+ category + " " + Object.keys(options).length);

  if (error) {
    return (
      //<div className="tag-category">
      <div class="form-group">
        <label> {category} </label>

        <TagAdder key={"add" + category + songId} category={category} onAdd={onAddTag} songId={songId} options={options} />
      </div>
    );
  }
  else
    return (
      <div class="form-group">
        <label> {category} </label>
        <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

          {tags.map((tag) => (
            <div style={{ padding: "20px" }}>
              <Tag
                key={tag + songId}
                type="d"
                tag={tag}
                name={names[tag] || tag}
                songId={songId}
                onDelete={() => onDeleteTag(tag)}
              />
            </div>
          ))}
        </div>

{/*
        <h5>
          {`Add a tag to ${category}`}
        </h5>
        
        <div>
          <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

            {Object.entries(options).map(([tag, name]) => (
              <div style={{ padding: "20px" }}>
              <Tag
                key={tag + songId}
                type="a"
                tag={tag}
                name={name}
                onAdd={() => onAddTag(tag)}
              />
              </div>
            ))}
          </div>


        </div>
        */}
        <TagAdder key={"add" + category + songId} category={category} onAdd={onAddTag} songId={songId} options={options} />
      </div>
    );
}

function Artist({ artistId, artist, categories, names, onAddTag, onDeleteTag, options, songId }) {
  if (options == undefined) {
    options = {};
  }
  //console.log("ARTIST:" + Object.keys(options).length);
  return (
    <div className="artist">
      <h1>{names[artistId]}</h1>

      {Object.entries(artist).map(([category, tags]) => (
        <TagCategory
          key={category + artistId}
          category={categories[category] || category}
          tags={tags || []}
          options={options}
          names={names}
          songId={songId}
          onAddTag={(newTag) => onAddTag(artistId, category, newTag)}
          onDeleteTag={(tag) => onDeleteTag(artistId, category, tag)}
        />
      ))}

    </div>
  );
}

function SongMetadataEditor({ onAddTag, onDeleteTag }) {
  const songData = useSongData();
  let optionCategoryMatches = { "l": "l", "g": "g", "b": "l", "o2": "l", "c": "l", "s": "l", "y": "y", "o": "o" };
  let options = songData.options;
  if (options == undefined) {
    options = {};
  }

  //console.log("SONGMETADATA:" + JSON.stringify(Object.keys(songData), null, 4));

  return (
    <div className="song-metadata-editor">
      {/*<h2>Edit Song Metadata</h2>*/}
      <div class="form-card" style={{ marginTop: "20px", width: "620px", marginBottom: "20px" }}>
        <h2> Edit Song Info (Advanced Users) </h2>
        <div className="tags-section">
          {/*<h1>Song Tags</h1>*/}
          {Object.entries(songData.tags).map(([category, tags]) => (
            <TagCategory
              key={category + songData.id}
              songId={songData.id}
              options={(category in optionCategoryMatches) ? options[optionCategoryMatches[category]] : {}}
              category={songData.categories[category] || category}
              tags={tags || []}
              names={songData.names}
              onAddTag={(newTag) => onAddTag('tags', category, newTag)}
              onDeleteTag={(tag) => onDeleteTag('tags', category, tag)}
            />

          ))}
        </div>
      </div>

      <div class="form-card" style={{ marginTop: "20px", width: "620px", marginBottom: "20px" }}>
      <h2> Edit Artists Info (Advanced Users) </h2>
        <div className="artists-section">
          {/*<h1>Associated Artists</h1>*/}
          {Object.entries(songData.artists).map(([artistId, artist]) => (
            <Artist
              key={artistId}
              artistId={artistId}
              songId={songData.id}
              artist={artist}
              options={options["l"]}
              categories={songData.categories}
              names={songData.names}
              onAddTag={(artistId, category, newTag) =>
                onAddTag(`artists.${artistId}`, category, newTag)
              }
              onDeleteTag={(artistId, category, tag) =>
                onDeleteTag(`artists.${artistId}`, category, tag)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SongMetadataEditor;
